import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { Header } from './components/Layout/Header';
import { BurnPermit } from './pages/BurnPermit/BurnPermit';
import EditBurnPermit from './pages/BurnPermit/EditBurnPermit';
import { ConstructionPermit } from './pages/ConstructionPermit';
import { FuelTankPermit } from './pages/FuelTankPermit';
import { Pyrotechnics } from './pages/Pyrotechnics';
import { HazMatPermit } from './pages/HazMatPermit';
import { BlastingPermit } from './pages/BlastingPermit';

import { Footer } from './components/Layout/Footer';
import { CSSTransition } from 'react-transition-group';

export default function App() {
	return (
		<BrowserRouter basename={'/' + (process.env.REACT_APP_URL_PREFIX || '')}>
			<CSSTransition in={true} appear={true} timeout={500} classNames="fade">
				<Header />
			</CSSTransition>
			<CSSTransition in={true} appear={true} timeout={500} classNames="fade">
				<Switch>
					<Route path="/" exact component={BurnPermit} />
					<Route
						path="/burn-permit/edit-application"
						component={EditBurnPermit}
					/>
					<Route path="/construction-permit" component={ConstructionPermit} />
					<Route path="/fuel-tank-permit" component={FuelTankPermit} />
					<Route path="/pyrotechnics" component={Pyrotechnics} />
					<Route path="/hazmat-permit" component={HazMatPermit} />
					<Route path="/blasting-permit" component={BlastingPermit} />
				</Switch>
			</CSSTransition>
			<CSSTransition in={true} appear={true} timeout={500} classNames="fade">
				<Footer />
			</CSSTransition>
		</BrowserRouter>
	);
}
